var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#35A1EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2659 22.22L34.3179 14.18C33.6095 13.7377 32.7911 13.5032 31.9559 13.5032C31.1207 13.5032 30.3023 13.7377 29.5939 14.18L16.6479 22.266C15.9118 22.7302 15.3276 23.3996 14.9672 24.1917C14.6069 24.9838 14.4861 25.8641 14.6199 26.724L17.9599 46.778C18.1364 47.8278 18.6827 48.7799 19.4999 49.4621C20.3171 50.1443 21.3514 50.5118 22.4159 50.498H41.5799C42.6447 50.5122 43.6795 50.145 44.4971 49.4628C45.3148 48.7805 45.8613 47.8282 46.0379 46.778L49.3779 26.724C49.5122 25.8483 49.3827 24.9524 49.0058 24.1506C48.629 23.3488 48.0219 22.6774 47.2619 22.222",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.222 31.0759H26.78C25.338 31.0759 24.168 32.1559 24.168 33.4919V40.7379C24.168 42.0719 25.338 43.1539 26.78 43.1539H37.224C38.666 43.1539 39.836 42.0719 39.836 40.7379V33.4919C39.836 32.1579 38.666 31.0759 37.224 31.0759",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1699 31.076V28.662C27.1699 28.0277 27.2949 27.3997 27.5376 26.8137C27.7803 26.2277 28.1361 25.6952 28.5846 25.2467C29.0331 24.7982 29.5656 24.4424 30.1516 24.1997C30.7376 23.957 31.3656 23.832 31.9999 23.832C32.6342 23.832 33.2623 23.957 33.8483 24.1997C34.4343 24.4424 34.9667 24.7982 35.4152 25.2467C35.8638 25.6952 36.2195 26.2277 36.4623 26.8137C36.705 27.3997 36.8299 28.0277 36.8299 28.662V31.076",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.d0f8ca9e625ab0a6c0106032ea148307.svg";
export { ForwardRef as ReactComponent };